import React, { Component, Fragment } from 'react';
import { CardLayout, TableLayout } from '../containers/Layout';
import { TableRow, TableCell, Button, Grid, TableHead, TableFooter, Box, TableBody, Typography, IconButton } from '@material-ui/core';
import SingleTemplate from '../containers/SingleTemplate';
import SingleBL from './SingleBL';
import Currency from '../../../../commonModules/Currency';
import { isEmpty } from 'lodash-es';
import { CollectionsBookmark } from '@material-ui/icons';
import PopUp from '../../../../commonModules/interface/PopUp';
import PreviewLoc from '../localisations/PreviewLoc';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class SingleReappro extends Component {
    state = { 
        BL: false,
        local: {},
        pItem:{}, 
        productName: "",
        match_purchase: {}
    }

    componentDidMount = async () => {
        console.log("[INFO] MOUNTING SALE SINGLE ");
        const { sale, PURCHASES_REAPPRO} = this.props;
        const match_purchase = PURCHASES_REAPPRO[sale.reappro_purchase_id]

        if(match_purchase.received) {
            let req = await fetch("/stocks/locals/shop",{
                method:"POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ shopID: this.props.shopDest.id }),
                credentials: 'same-origin',
            })
            let res = await req.json()
    
            console.log("getShopLocal", {res});
            if(res.error){
                console.log("getShopLocal", res.error.error);
            } else {
                this.setState({
                    local: res.id != "" && res,
                    match_purchase: match_purchase
                })    
            }
        } 
    }

    openLocalMap = (pItem, productName) => {
        this.setState({
            openLocal : true,
            pItem,
            productName
        })
    }
    createProductList = () => {
        const { PRODUCTS, sale, shop } = this.props
        const { match_purchase } = this.state

        let op = !isEmpty(this.state.local) ? match_purchase : sale
        return op.products.map( saleItem => {
            let prod = PRODUCTS[saleItem.product_id]
            // Utiliser les bonnes propriétés HT et TTC
            const totalHT = parseFloat(saleItem.total_ht || saleItem.price_ht || saleItem.price || 0)
            const totalTTC = parseFloat(saleItem.total_ttc || saleItem.price_ttc || saleItem.cost || saleItem.price || 0)
            let PU_HT = saleItem.price_u || (totalHT / saleItem.quantity)

            return (
                <TableRow>
                    <TableCell className="text-left">{prod.name}</TableCell>
                    <TableCell>{saleItem.quantity}</TableCell>
                    {!this.props.draft &&
                        <>
                            <TableCell><Currency value={PU_HT} /></TableCell>
                            <TableCell><Currency value={totalHT} /></TableCell>
                            <TableCell><Currency value={totalTTC} /></TableCell>
                            <TableCell className="no-print">
                                {!isEmpty(this.state.local) && saleItem.purchase_item_rest > 0 &&
                                    <IconButton onClick={() => this.openLocalMap(saleItem, prod.name)}> 
                                    {/* saleItem == purchase item here */}
                                        <CollectionsBookmark />
                                    </IconButton>
                                }
                            </TableCell>
                            {/* <TableCell>{formatNumbers.format(PU)}</TableCell>
                            <TableCell>{formatNumbers.format(ssTt)}</TableCell>
                            <TableCell>{shop.TVA || 0} %</TableCell>
                            <TableCell>{formatNumbers.format(ssTt)}</TableCell> */}
                        </>
                    }
                </TableRow>
            )
        })
    }

    getTotal = () => {
        let totalHT = 0
        let totalTTC = 0
        const { sale } = this.props
        sale.products.map( saleItem => {
            const ht = parseFloat(saleItem.total_ht || saleItem.price_ht || saleItem.price || 0)
            const ttc = parseFloat(saleItem.total_ttc || saleItem.price_ttc || saleItem.cost || saleItem.price || 0)
            totalHT += ht
            totalTTC += ttc                              
        })
        
        return { totalHT, totalTTC }
    }
    
    render(){
        console.log("[STATE] PRODUCT",this.props);
        const { shop, shopDest, sale} = this.props;
        const { openLocal, pItem, productName} = this.state;
        let totals = this.getTotal()
        let totalHT = totals.totalHT
        let totalTTC = totals.totalTTC
        
        // ⚠️ IMPORTANT: Le surcout inclut déjà transport et taxes proportionnellement
        // dans le calcul du TTC de chaque produit (PriceTTC = PriceHT × Surcout)
        // où Surcout = (Transport + Taxes) / Total_HT + 1
        // Donc on ne doit PAS ajouter transport/taxes au totalTTC final
        // if( sale.taxes){
        //     totalTTC += sale.taxes
        // }
        // if( sale.transport){
        //     totalTTC += sale.transport
        // }
        return(
            <SingleTemplate
                shop={shop}    
                shopDest={shopDest}    
                sale={sale}   
                notif={this.props.notif} 
                handleBL={() => this.setState({ BL: !this.state.BL})}
                BL={this.state.BL}
                BLOpt
            >
                {this.state.BL ?
                    <SingleBL 
                        {...this.props}
                    />
                :
                <>
                    {openLocal &&
                        <PopUp
                            title={`Rangement ${productName}`}
                            close={() => this.setState({openLocal: false, pItem:{}, productName: ""})}
                            appbar
                        >
                            <PreviewLoc
                                {...this.state.local}
                                pItem={pItem}
                                productName={productName}
                            />
                        </PopUp>
                    }
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell className="text-left">Produit</TableCell>
                                <TableCell>Quantité</TableCell>
                                {!this.props.draft &&
                                    <>
                                        <TableCell>PU HT</TableCell>
                                        <TableCell>Total HT</TableCell>
                                        {/* <TableCell>PU Vente</TableCell> */}
                                        <TableCell>Total TTC</TableCell>
                                        <TableCell className="no-print">
                                            {!isEmpty(this.state.local) &&
                                                <span className="no-print">Ranger</span>
                                            }
                                        </TableCell>
                                    </>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.createProductList()}
                            
                            {!this.props.draft ?
                            <>
                                <TableRow>
                                    <TableCell colSpan={6} />
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} />
                                    <TableCell>Sous Total</TableCell>
                                    <TableCell><Currency value={totalHT} /></TableCell>
                                    <TableCell className="f-700"><Currency value={totals.totalTTC} /></TableCell>
                                    <TableCell className="no-print"/>
                                </TableRow>
                                <TableRow >
                                    <TableCell colSpan={4} style={{textAlign: "right", fontStyle: "italic", color: "#666"}} >
                                        Transport (inclus)
                                    </TableCell>
                                    <TableCell style={{fontStyle: "italic", color: "#666"}}>
                                        <Currency value={(sale.transport || 0)} />
                                    </TableCell>
                                    <TableCell className="no-print"/>
                                </TableRow>
                                <TableRow >
                                    <TableCell colSpan={4} style={{textAlign: "right", fontStyle: "italic", color: "#666"}} >
                                        Autres Taxes (inclus)
                                    </TableCell>
                                    <TableCell style={{fontStyle: "italic", color: "#666"}}>
                                        <Currency value={(sale.taxes || 0)} />
                                    </TableCell>
                                    <TableCell className="no-print"/>
                                </TableRow>
                            </>
                            :
                            <>
                                <TableCell colSpan={2} />
                                <TableRow >
                                    <TableCell style={{textAlign: "right", fontStyle: "italic", color: "#666"}} >
                                        Transport (inclus)
                                    </TableCell>
                                    <TableCell style={{fontStyle: "italic", color: "#666"}}>
                                        <Currency value={(sale.transport || 0)} />
                                    </TableCell>
                                </TableRow>
                                <TableRow >
                                    <TableCell style={{textAlign: "right", fontStyle: "italic", color: "#666"}} >
                                        Autres Taxes (inclus)
                                    </TableCell>
                                    <TableCell style={{fontStyle: "italic", color: "#666"}}>
                                        <Currency value={(sale.taxes || 0)} />
                                    </TableCell>
                                </TableRow>
                            </>
                            }
                        </TableBody>   
                        <TableFooter> 
                            <TableRow>
                                <TableCell colSpan={this.props.draft ? 1 : 4} style={{textAlign: "right"}}>
                                    <Typography variant="h6">TOTAL</Typography>
                                    </TableCell>
                                <TableCell className="f-700">
                                    <Typography variant="h6"><b><Currency value={(totalTTC || 0)} /></b></Typography>
                                    {/* {formatNumbers.format(totalTTC)} */}
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                        </TableFooter>
                    </TableLayout>   
                    </>  
                }
            </SingleTemplate>
        )
    }
}

export default SingleReappro;